import styled from "styled-components";

import { ThemeProp } from "styles/theme";
import { datastoresMenuFonts } from "styles/font-sizes";

export const CategoryName = styled.div`
  font-size: ${datastoresMenuFonts.datastoreTitle}px;
  opacity: 0.7;
`;

export const StyledHorizontalLine = styled.div`
  height: 2px;
  background: ${({ theme }: ThemeProp) => theme.textInLight};
  opacity: 0.2;
`;
